// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-link_root__H6SrK"};